import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SessionService } from '../components/services/app-state-services/session/session.service';

@Injectable({
  providedIn: 'root'
})
export class RequestInterceptorService implements HttpInterceptor {
  constructor(private _sessionService: SessionService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith('/assets/')) {
      return next.handle(req);
    }

    if (req.url.startsWith('http')) {
      const tenantReq = this.injectTenantHeader(req);
      return next.handle(tenantReq);
    }

    const domainMap: { [domain: string]: string[] } = {};
    let baseUrl = environment.apiURL;

    for (const [domain, prefixes] of Object.entries(domainMap)) {
      if (prefixes.some(prefix => req.url.startsWith(prefix))) {
        baseUrl = domain;
        break;
      }
    }

    const modifiedReq = this.injectTenantHeader(
      req.clone({ url: `${baseUrl}${req.url}` })
    );

    return next.handle(modifiedReq);
  }

  /**
   * Adds X-Tenant-Code and (when available) X-Workshop-Id headers.
   * Never throws — the backend rejects unauthenticated calls with its own error.
   */
  private injectTenantHeader(req: HttpRequest<any>): HttpRequest<any> {
    const headers: Record<string, string> = {};

    const tenantCode = this._sessionService.getTenantCode();
    if (tenantCode) {
      headers['X-Tenant-Code'] = tenantCode;
    }

    const workshopId = this._sessionService.getWorkshopId();
    if (workshopId) {
      headers['X-Workshop-Id'] = workshopId;
    }

    if (Object.keys(headers).length === 0) {
      return req;
    }
    return req.clone({ setHeaders: headers });
  }
}
